import {useCallback, useState} from "react";

const useInputValue = (initValue) => {
    const [value, setValue] = useState(initValue);


    //INPUT EVENT ONLY
    const onChangeValue = useCallback((e) => {
        if (e?.target?.value !== undefined) {
            setValue(e?.target?.value)
        }

    }, [])

    return [value, onChangeValue,setValue];
}



export default useInputValue